export function hasValidSubject(meeting) {
    return !!meeting.subject && meeting.subject.length >= 0;
}
